module.exports = __webpack_public_path__ + "images/landing/banner/help-img-3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-3.png
// module id = whPB
// module chunks = 55